import { createSyncRunner } from '../platform/sync-runner';
import { rdb, RECEPT_TABLE_MAP } from './db';

/**
 * The recepten sync loop — the platform runner bound to this module's own Dexie
 * database, outbox and endpoint. Started alongside (and independently of) the
 * groceries, agenda and todo loops when the app is signed in.
 */
export const recipeSync = createSyncRunner({
  endpoint: '/api/v1/recepten/sync',
  db: rdb,
  outbox: rdb.outbox,
  meta: rdb.meta,
  rejections: rdb.rejections,
  tables: RECEPT_TABLE_MAP,
  sinceKey: 'recepten_since',
  lastOkKey: 'recepten_last_ok',
});

export const startRecipeSync = () => recipeSync.startLoop();
